import Vue from 'vue'
import Router from 'vue-router'
import HeadedView from '@/views/HeadedView'
import ItemsView from '@/views/ItemsView'
import ItemView from '@/views/ItemView'
import ContactView from '@/views/ContactView'

Vue.use(Router)

export default new Router({
	routes: [
		{
			path: '/',
			component: HeadedView,
			children: [{
				path: '/',
				name: 'gallery',
				component: ItemsView
			},{
				path: '/contact',
				name: 'contact',
				component: ContactView
			}]
		},
		{
			path: '/item/:id',
			name: 'item',
			component: ItemView,
			props: true
		}
	]
})
